"use strict";

(function (global) {

  /**
  * Функции отвечающие за работу пенелей инструментов
  * @namespace Core.sideBar
  * @since 5.0.0.4200
  */
  global.sideBar = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
})(window.Core);


(function (global) {
  global.tabSelector = "div.tab_item";
  global.tab = 0;

  global.initTabs = function () {
    var url = new WA.URL();
    var view = url.getParam('view').toLowerCase();           
    if (view == "card" || !view) {
      if ($('.CardForm_Tab').length) {
        Core.sideBar.updateTab();
      }
      // Подпишемся на событие смены вкладки, чтобы при переходе на реактивную вкладку проверялось наличие изменений.
      $('html').bind(PAGE_EVENTS.ON_BEFORE_TAB_CHANGE, (event) => {
        event.currentTarget.isModifiedByUser = WA.CR.form.isChanged();
      });
    }    
    return global;
  };

  global.updateTab = function (tab) {
    var me = global;
    var tabGiven;
    const url = new WA.URL();
    const previousTab = /Tab(\d+)/.exec(url.getHash());
    if (tab) {
      me.tab = tab;
      tabGiven = true;
    } else {     
      if (previousTab) {
        me.tab = parseInt(previousTab[1], 10);
      }        
      tabGiven = false;
    }
    
    var SB = WA.CR.sideBar;
    if (!me.tab || me.tab <= 0 || ($('#TabHeader' + me.tab).length == 0 && $('#ViewList_TabHeader' + me.tab).length == 0)) {
      SB.tabs.toArray().forEach(function (tab, index) {
        if (!me.tab && tab.isVisible()) {
          me.tab = index + 1;
        }
      });
    }
    if (tabGiven && url.getParam('view') && url.getParam('view').toLowerCase() != "card" && url.getParam('mode').toLowerCase() != "new") {
      url.setParam('view', 'Card');      
      let newUrl = url.asString();
      if (previousTab) {
        newUrl = newUrl.replace(previousTab[0], `Tab${me.tab}`);
      } else {
        newUrl += `#Tab${me.tab}`;
      }
      try {
        //UnbindBeforeUnload();
        window.location.href = newUrl;
      } catch (_) { }
    } else {
      $('.CardForm .CardForm_Tab').hide();
      var jCardFormTabs = $('.CardFormTabs');
      if (jCardFormTabs.length) { // вкладки сверху
        jCardFormTabs.find('li').removeClass('background');
        $('#TabHeader' + me.tab, jCardFormTabs).addClass('background');
      } else { // вкладки сбоку

        var jSelectedTab;
        if (me.tab > 1) {
          jSelectedTab = $('.tab_item#ViewList_TabHeader' + me.tab);
        } else {
          jSelectedTab = $('.tab_item#ViewList_Card');
        }

        var tabName = jSelectedTab.attr('name');      
        //TODO Шамов А.: События должны fire внутри класса, а не где попало.
        if (SB) SB.fire(SB['class'].EVENT.BEFORE_TAB_SWITCH, SB.tabs[tabName]);

        var jTabItem = $('.tab_item');
        jTabItem.removeClass('selected');
        jSelectedTab.addClass('selected');
        window.location.hash = "Tab" + me.tab;

        //TODO Шамов А.: События должны fire внутри класса, а не где попало.
        if (SB) SB.fire(SB['class'].EVENT.AFTER_TAB_SWITCH, SB.tabs[tabName]);
      }

      $('.CardForm #CardForm_Tab_' + tabName).show();
      if (me.tab == 1) $('.CardForm #CardForm_Tab_Card').show();
    }

    // $('.CardForm .datatable').dataTable().fnDraw();
    var dtTables = $('.CardForm div.dataTables_scrollBody .refrecord_table');
    if (dtTables.length > 0) {
      for (var i = 0; i < dtTables.length; i++) {
        $(dtTables[i]).dataTable().fnDraw();
      };
    };

    return global;
  };


  /**
  * 
  * @function Core.sideBar.isHorizontal
  * @since 5.0.0.4200  
  * @return {boolean}
  */
  global.isHorizontal = function () {
    return $(window).width() < $(window).height();
  };

  /**
  * 
  * @function Core.sideBar.setOrientationCookie
  * @since 5.0.0.4200  
  * @return {integer}
  */
  global.setOrientationCookie = function (isNeedInvert) {
    var isHorizontal = global.isHorizontal();
    if (isNeedInvert === true) isHorizontal = !isHorizontal;
    $.cookie("IsHorizontal", isHorizontal ? "1" : "0");
  };

  /**
  * 
  * @function Core.sideBar.setHorizontal
  * @since 5.0.0.4200  
  * @return {integer}
  */
  global.setHorizontal = function () {
    WA.SideBarInit.done(function () {
      WA.current.sideBar.setOrientation(ORIENTATION.HORIZONTAL);
    });
  };

  /**
  * Устновить нормальную ориентацию сайдбара.
  * @function Core.sideBar.setVertical
  * @since 5.0.0.4200  
  * @return {integer}
  */
  global.setVertical = function () {
    WA.SideBarInit.done(function () {
      WA.current.sideBar.setOrientation(ORIENTATION.VERTICAL);
    });
  };

})(window.Core.sideBar);